import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationCrosshairs } from "@fortawesome/pro-solid-svg-icons/faLocationCrosshairs";
import { Button, cn } from "@wondermaps/ui";

interface RecenterButtonProps {
  /** Whether location is currently available */
  hasLocation: boolean;
  /** Called when button is clicked - either to request permission or recenter */
  onClick: () => void;
  /** Additional classes */
  className?: string;
}

/**
 * Persistent location button in bottom-right corner.
 * - Gray when location not enabled (tap to request permission)
 * - Blue when location enabled (tap to recenter map)
 */
export function RecenterButton({ hasLocation, onClick, className }: RecenterButtonProps) {
  const { t } = useTranslation("map");
  return (
    <Button
      variant="secondary"
      size="icon"
      onClick={onClick}
      aria-label={hasLocation ? t("recenter") : t("list.enableLocation")}
      className={cn(
        "absolute bottom-[calc(6rem+env(safe-area-inset-bottom,0px))] right-4 z-10 shadow-md transition-colors",
        hasLocation && "bg-primary text-primary-foreground hover:bg-primary/90",
        className
      )}
    >
      <FontAwesomeIcon icon={faLocationCrosshairs} className="h-5 w-5" />
    </Button>
  );
}
